import { Theme } from '@apia/theme';
import layout from './styles/layout';
import buttons from './styles/buttons';
import grids from './styles/grids';
import menu from './global/menu';
import transitions from './global/transitions';
import animations from './global/animations';
import { files } from './global/files';
import print from './global/print';
import gantt from './global/gantt';

const makeTheme = <T extends Theme>(t: Omit<T, 'palette'>) => t;

export default function getBurocrat() {
  return makeTheme({
    buttons,
    grids,
    layout: layout(),
    styles: {
      root: {
        ...menu,
        ...transitions,
        ...animations,
        ...files,
        ...print,
        ...gantt,
      },
    },
  });
}

// https://theme-ui.com/guides/typescript/
export type TBurocratTheme = ReturnType<typeof getBurocrat>;
// https://theme-ui.com/theme-spec/
